




import Vue, { PropType } from "vue";

export interface DateProps {
  ts: string;
  locale: string;
  format: string;
  isShowHour: boolean;
}

export interface DateData {
  displayFormat: string;
  dateStringOptions: {
    year: string;
    month: string;
    day: string;
    hour: string;
  };
}

/**
 * フォーマットから日付を変換表示
 */
function formatDate(date: Date, format: string): string {
  const yyyy = date.getFullYear();
  const mm = ("0" + (date.getMonth() + 1)).slice(-2);
  const dd = ("0" + date.getDate()).slice(-2);
  const hh = ("0" + date.getHours()).slice(-2);
  const mi = ("0" + date.getMinutes()).slice(-2);

  format = format.replace(/yyyy/g, yyyy + "");
  format = format.replace(/M/g, mm);
  format = format.replace(/d/g, dd);
  format = format.replace(/H/g, hh);
  format = format.replace(/m/g, mi);
  format = format.replace(/s/g, String(date.getSeconds()));
  format = format.replace(/S/g, String(date.getMilliseconds()));

  return format;
}

export default Vue.extend({
  name: "vc-date",
  props: {
    ts: {
      type: String as PropType<DateProps["ts"]>,
      default: "",
    },
    locale: {
      type: String as PropType<DateProps["locale"]>,
      default: "ja-jp",
    },
    format: {
      type: String as PropType<DateProps["format"]>,
      default: "yyyy.M.d",
    },
    isShowHour: {
      type: Boolean as PropType<DateProps["isShowHour"]>,
      default: false,
    },
  },
  computed: {
    convertDate(): string {
      const date = new Date(Number(this.ts) * 1000);
      if (this.locale === "ja-jp" || this.locale === "zh-tw") {
        return formatDate(date, this.format);
      } else {
        let options = {};
        if (this.isShowHour) {
          options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
          };
        } else {
          options = {
            year: "numeric",
            month: "short",
            day: "numeric",
          };
        }

        return date.toLocaleDateString(this.locale, options);
      }
    },
  },
});
